import {useNavigate} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {HeaderDashboard, SideNav} from "../Componat/Header and Side Nav/NavComponant";
import {BaseURL} from "../../../API/API";
import {useDispatch} from "react-redux";
import {setForm8Data} from "../../Redux/Reduser/Reducer";
import {IoMdPrint} from "react-icons/io";
import ReactPaginate from "react-paginate";
import {FaEdit} from "react-icons/fa";

export default function () {
    const [isOpen, setIsOpen] = useState(true);
    const toggleSidebar = () => setIsOpen(!isOpen);

    return  (
        <div className="d-flex flex-column min-vh-100">
            <HeaderDashboard toggleSidebar={()=>{toggleSidebar()}}/>
            <div className="d-flex flex-grow-1">
                <SideNav isOpen={isOpen}/>

                {/* Main Content */}
                <main className={`p-4 w-100 main`}>
                    <Form9Data />
                </main>
            </div>
        </div>
    )
}


const Form9Data=React.memo(()=>{

    const navigate = useNavigate();
    const [form8Data,setForm8Data]=useState([]);
    const [searchType,setSearchType]=useState("All")
    const [searchText,setSearchText]=useState("")
    const [activePage,setActivePage]=useState(0);
    const [pageCount,setPageCount]=useState(0);
    useEffect(() => {
        CountPage();
        ReadRecord();
    }, []);

    function Add() {
        navigate("/admin/Form8AddInformation");
    }
    function Search() {
        CountPage();
        ReadRecord();
    }

    const handlePrint = () => {
        const printWindow = window.open("", "", "height=800,width=1000");

        printWindow.document.write(`
    <html>
      <head>
        <title>Print Table</title>
        <style>
          @media print {
            @page {
              size: legal portrait;
              margin: 10px;
              margin-top: 100px;
            }

            th:first-child,
            td:first-child {
              display: none;
            }

            body {
              margin: 0;
            }
          }

          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            border: 1px solid black;
            page-break-inside: auto;
          }

          th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
            vertical-align: top;
          }

          th {
            background-color: #3f51b5;
            color: white;
            font-weight: bold;
          }

          tr:nth-child(even) {
            background-color: #f2f2f2;
          }

          tr:hover {
            background-color: #e0e0e0;
          }
        </style>
      </head>
      <body>
        ${document.getElementById("TableList").innerHTML}
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };

    function ReadRecord() {
        let form = new FormData();
        form.append('VilageName',JSON.parse(sessionStorage.getItem('data'))[0].VilageName);
        form.append('searchType',searchType);
        form.append('activePage',activePage);
        form.append('searchText',searchText);

        fetch(BaseURL + 'GM.php/ReadForm8', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {
                    if(data!="[]"){
                        const parsedData = JSON.parse(data); // First level parse
                        // If it's a JSON array:
                        if (Array.isArray(parsedData)) {
                            setForm8Data(parsedData);
                        }
                        else if (typeof parsedData === 'string') {
                            const innerParsed = JSON.parse(parsedData);
                            setForm8Data(innerParsed);
                        }
                    }



                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });
    }

    function CountPage() {
        let form = new FormData();
        form.append('VilageName',JSON.parse(sessionStorage.getItem('data'))[0].VilageName);
        form.append('searchType',searchType);
        form.append('searchText',searchText);

        fetch(BaseURL + 'GM.php/ReadForm8Count', {
            method: 'POST',
            body: form
        })
            .then(res => res.text()) // Or use .json() if response is valid JSON
            .then(data => {
                try {
                    const parsedData = JSON.parse(data); // First level parse
                    setPageCount(parseInt(JSON.parse(parsedData)[0].total/20));
                } catch (e) {
                    console.error("Parsing error:", e);
                }
            })
            .catch(err => {
                console.error("Fetch error:", err);
            });


    }

    return <>
        <div className="mt-2 p-3 card">
            <h1>Form9</h1>ग्रामपंचायत नमूना ९
        </div>

        <div className="card">
            <div className="d-flex justify-content-between">
                <div className="mt-2 p-3">
                    {/*<span className={"m-1"}><MdMenu/></span>*/}
                    <span onClick={handlePrint} className={"m-1"}><IoMdPrint/></span>
                </div>
                <div className="mt-2 p-3">
                    <select onChange={(e)=>setSearchType(e.target.value)} className="form-control d-inline-block w-auto" name="selSearch">
                        <option value="All">All</option>
                        <option value="Property_No">मालमत्ता क्र.</option>
                        {/*<option value="GramPanchayat_Name1">गाव</option>*/}
                        <option value="Owner_Name">घरमालकाचे नाव</option>
                    </select>
                    <input onChange={(e)=>setSearchText(e.target.value)} className="form-control d-inline-block w-auto mx-2" />
                    <button onClick={Search} className="btn btn-primary d-inline-block">Search</button>
                    {/*<button onClick={Add} className="btn btn-primary d-inline-block mx-2">Add</button>*/}
                </div>
            </div>

            <TableForm9 form8Data={form8Data}/>
            <ReactPaginate
                pageCount={pageCount}
                onPageChange={(data) => {
                    const selectedPage = data.selected + 1;
                    setActivePage(selectedPage);
                }}
                containerClassName={"pagination"}
                activeClassName={"active"}
            />
        </div>


    </>
})


const TableForm9=React.memo(({form8Data})=>{
    const navigate = useNavigate();
    const dispatch=useDispatch();


    function Edit(item) {
        dispatch(setForm8Data(item));
        navigate("/admin/form9Edit");
    }
    function Print(item) {
        dispatch(setForm8Data(item));
        navigate("/admin/Form9PrintPage");
    }

    return <>
        <div id={"TableList"} className={"w-100 form-table"}>
            <table  className="table custom-table2">
                <thead>
                <tr>
                    {/*-----1----*/}
                    <td></td>
                    {/*-----2----*/}
                    <td>Sr.No.</td>
                    {/*-----3----*/}
                    <td>अनु क्र.</td>
                    {/*-----4----*/}
                    <td>मालमत्ता क्र.</td>
                    {/*-----5----*/}
                    <td>गाव</td>
                    {/*-----6----*/}
                    <td>घरमालकाचे नाव</td>
                    {/*-----7----*/}
                    <td>पत्नीचे नाव</td>
                    {/*-----8----*/}
                    <td>भोगवटदाराचे नाव</td>
                    {/*-----9----*/}
                    <td>पु.प</td>
                    {/*-----10----*/}
                    <td>उ. द.</td>
                    {/*-----11----*/}
                    <td>मालमत्तेचे वर्णन</td>
                    {/*-----12--new data--*/}
                    <td>थ.गृहकर</td>
                    {/*-----13----*/}
                    <td>थ.खाली जागा</td>
                    {/*-----14----*/}
                    <td>थ.वीजकर</td>
                    {/*-----15----*/}
                    <td>थ. आरोग्य कर</td>
                    {/*-----16----*/}
                    <td>ए.गृहकर</td>
                </tr>
                </thead>
                <tbody>
                {
                    form8Data.map((item,index)=>(
                        <tr id={`row-${index}`}>
                            <td>
                                <span onClick={()=>{Edit(item)}} className={"m-1 pointer-curser"}><FaEdit/></span>
                                <span onClick={()=>{Print(item)}} className={"m-1 pointer-curser"}><IoMdPrint/></span>
                            </td>
                            {/*=======1======*/}
                            <td>{index+1}</td>
                            {/*=======2======*/}
                            <td>{item.Sr_No}</td>
                            {/*=======3======*/}
                            <td>{item.Property_No}</td>
                            {/*=======4======*/}
                            <td>{item.GramPanchayat_Name1}</td>
                            {/*=======5======*/}
                            <td>{item.Owner_Name}</td>
                            {/*=======6======*/}
                            <td>{item.Wife_Name}</td>
                            {/*=======7======*/}
                            <td>{item.Occupant_Name}</td>
                            {/*=======7======*/}
                            <td>{JSON.parse(item.Col8).total_area_east_west1}</td>
                            {/*=======8======*/}
                            <td>{JSON.parse(item.Col8).total_area_north_south1}</td>
                            {/*=======9======*/}
                            <td>{JSON.parse(item.ExtendData)[0].Col9}</td>
                            {/*=======10======*/}
                            <td>{JSON.parse(item.Box).box5}</td>
                            {/*=======11======*/}
                            <td>{JSON.parse(item.Box).box6}</td>
                            {/*=======12======*/}
                            <td>{parseFloat(JSON.parse(item.ExtendData)[0].Col19_Gruhakar).toFixed(3)}</td>
                            {/*=======13======*/}
                            <td>{parseFloat(item.Col20).toFixed(3)}</td>
                        </tr>
                    ))
                }
                </tbody>
            </table>
        </div>
    </>

});